import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../../constants/assets/containers";
import { connect } from "react-redux";
import NoFooterModal from "../../../Common/NoFooterModal";
import InfiniteScrollDropdown from "../../../Common/InfiniteScrollDropdown";
import PaginatedReactDropdown from "../../../Common/PaginatedReactDropdown";
import { bindActionCreators } from "redux";
import * as CountryActions from "../../../../store/actions/Country";
import * as StateActions from "../../../../store/actions/State";
import * as CityActions from "../../../../store/actions/City";
import * as LocalityActions from "../../../../store/actions/Locality";
import * as DriverActions from "../../../../store/actions/DriverServices";
import { FlexContainer } from "../../../../constants/assets/containers";
import styled from "styled-components";
import { isValNull } from "../../../../utils";

const GeographyDetailsModal = (props) => {
  const {
    setModalState,
    inputFieldState,
    setInputFieldState,
    getInputLabel,
    newCampaignOptions,
  } = props;

  const [formError, setFormError] = useState("");

  const geographyLevelType = [
    // { label: "Country", value: "country" },
    { label: "State", value: "state" },
    { label: "City", value: "city" },
    { label: "Locality", value: "locality" },
  ];

  const [driverServicesPriorityFlag, setDriverServicesPriorityFlag] =
    useState(true);
  const [cityPriorityFlag, setCityPriorityFlag] = useState(true);
  const [statePriorityFlag, setStatePriorityFlag] = useState(false);
  const [countryPriorityFlag, setCountryPriorityFlag] = useState(false);

  const [cityLocalityPriorityFlag, setCityLocalityPriorityFlag] =
    useState(false);
  const [localityPriorityFlag, setLocalityPriorityFlag] = useState(false);

  const handleClose = () => {
    setInputFieldState((prevState) => {
      return {
        ...prevState,
        geography_details: {
          geography_level: "city",
          country_id: "",
          state_ids: [],
          city_ids: [],
          loality_city_ids: [],
          locality_ids: [],
          driver_service_ids: [],
          active_driver_option: "",
        },
        driver_selection_type: "",
      };
    });
    setModalState(false);
  };

  const validateGeographyDetails = () => {
    if (isValNull(inputFieldState.geography_details.geography_level)) {
      return "Geography level field is mandatory";
    }

    let err = "";
    Object.keys(inputFieldState.geography_details).map((key) => {
      if (isValNull(inputFieldState.geography_details[key])) {
        switch (inputFieldState.geography_details.geography_level) {
          case "country":
            if (key == "country_id") {
              err = "Country field is mandatory";
            }
            break;
          case "state":
            if (key == "state_ids") {
              err = "State field is mandatory";
            }
            break;
          case "city":
            if (key == "city_ids") {
              err = "City field is mandatory";
            }
            break;
          case "locality":
            if (key == "locality_ids") {
              err = "Locality field is mandatory";
            }
            break;
        }
      }
    });

    return err ? err : "validated";
  };

  const handleSubmit = () => {
    let validatedState = validateGeographyDetails();
    if (validatedState === "validated") {
      setModalState(false);
    } else {
      setFormError(validatedState);
    }
  };

  const handleChange = (key, val) => {
    var geographyDetails = inputFieldState.geography_details;
    geographyDetails[key] = val;
    if (key == "geography_level") {
      setTimeout(() => {
        switch (val) {
          case "city":
            setCityPriorityFlag(true);
            break;
          case "state":
            setStatePriorityFlag(true);
            break;
          case "country":
            setCountryPriorityFlag(true);
            break;
          case "locality":
            setCityLocalityPriorityFlag(true);
            break;
        }
      }, 100);
    }
    if (key == "locality_city_ids") {
      if (geographyDetails[key].length == 0) {
        geographyDetails["locality_ids"] = [];
      } else {
        setLocalityPriorityFlag(true);
      }
    }
    setInputFieldState((prevState) => {
      return { ...prevState, geography_details: geographyDetails };
    });
  };

  const getConfirmButton = () => {
    return (
      <BottomSectionModal className="flex justify-center ">
        <Button
          data-testid="submitGeographyDetailsModal"
          className="sushi-btn"
          onClick={handleSubmit}
        >
          Confirm
        </Button>
      </BottomSectionModal>
    );
  };

  const getGeographySelectedDropdown = () => {
    switch (inputFieldState.geography_details.geography_level) {
      case "country":
        return (
          <InfiniteScrollDropdown
            priorityFlag={countryPriorityFlag}
            setPriorityFlag={setCountryPriorityFlag}
            id="driverCommCountryDropdown"
            getActiveList={props.getCountryList}
            nextPage={props.nextPageCountry}
            resKey="countries"
            modalState="Edit"
            keyName="country_id"
            labelKey="country_name"
            getDataLabelKey="country.country_name"
            keyTypeToSet="id"
            label="Country"
            handleChange={handleChange}
            remoteSearchApplicable={false}
            activeElement={inputFieldState.geography_details}
            appliedFilters={{}}
            getActiveItemById={props.getCountry}
            // remoteSearchKey="startswith"
          />
        );
      case "state":
        return (
          <InfiniteScrollDropdown
            priorityFlag={statePriorityFlag}
            setPriorityFlag={setStatePriorityFlag}
            id="driverCommStateDropdown"
            getActiveList={props.getStateList}
            nextPage={props.nextPageState}
            resKey="states"
            modalState="Edit"
            keyName="state_ids"
            labelKey="name"
            getDataLabelKey="state.name"
            keyTypeToSet="id"
            label="State"
            handleChange={handleChange}
            remoteSearchApplicable
            activeElement={inputFieldState.geography_details}
            appliedFilters={{}}
            getActiveItemById={props.getBulkStates}
            remoteSearchKey="startswith"
            multiple
          />
        );

      case "city":
        return (
          <InfiniteScrollDropdown
            priorityFlag={cityPriorityFlag}
            setPriorityFlag={setCityPriorityFlag}
            id="driverCommCityDropdown"
            getActiveList={props.getCityList}
            nextPage={props.nextPageCity}
            resKey="cities"
            modalState="Edit"
            keyName="city_ids"
            labelKey="city_name"
            getDataLabelKey="city.city_name"
            keyTypeToSet="id"
            label="City"
            handleChange={handleChange}
            remoteSearchApplicable
            remoteSearchKey="startswith"
            activeElement={inputFieldState.geography_details}
            appliedFilters={{}}
            getActiveItemById={props.getBulkCities}
            multiple
          />
        );
      case "locality":
        return (
          <InfiniteScrollDropdown
            priorityFlag={localityPriorityFlag}
            setPriorityFlag={setLocalityPriorityFlag}
            id="driverCommLocalityDropdown"
            getActiveList={props.getLocalityList}
            nextPage={props.nextPageLocality}
            resKey="localities"
            modalState="Edit"
            keyName="locality_ids"
            labelKey="locality_name"
            getDataLabelKey="locality.locality_name"
            keyTypeToSet="id"
            label="Locality"
            handleChange={handleChange}
            remoteSearchApplicable
            activeElement={inputFieldState.geography_details}
            getActiveItemById={props.getBulkLocalities}
            appliedFilters={
              inputFieldState.geography_details.locality_city_ids
                ? {
                    city_id:
                      inputFieldState.geography_details.locality_city_ids,
                  }
                : {}
            }
            remoteSearchKey="startswith"
            disabled={isValNull(
              inputFieldState.geography_details.locality_city_ids
            )}
            multiple
          />
        );
    }
  };

  return (
    <NoFooterModal
      header={true}
      heading="Select Geography and Driver Details"
      handleClose={handleClose}
      id="GeographyDetailsModal"
      modalButtons={getConfirmButton()}
    >
      <div>
        <FlexContainer className="justify-start">
          <NamesDiv>
            <p className="regular ml-10 mb-30">Select Geography Level</p>
          </NamesDiv>
          <InputElements>
            <PaginatedReactDropdown
              placeholder=""
              options={geographyLevelType}
              labelKey="label"
              valueKey="value"
              data-testid="geographyLevelType"
              value={getInputLabel(
                inputFieldState.geography_details.geography_level,
                geographyLevelType,
                "value",
                "label"
              )}
              handleChange={handleChange}
              keyToChange="geography_level"
              id="geographyLevelType"
            />
          </InputElements>
        </FlexContainer>
        {inputFieldState.geography_details.geography_level == "locality" && (
          <FlexContainer className="justify-start">
            <NamesDiv>
              <p className="regular ml-10 mb-30">Select city for localities</p>
            </NamesDiv>
            <InputElements>
              <InfiniteScrollDropdown
                priorityFlag={cityLocalityPriorityFlag}
                setPriorityFlag={setCityLocalityPriorityFlag}
                id="driverCommCity2Dropdown"
                getActiveList={props.getCityList}
                nextPage={props.nextPageCity}
                resKey="cities"
                modalState="Edit"
                keyName="locality_city_ids"
                labelKey="city_name"
                getDataLabelKey="city.city_name"
                keyTypeToSet="id"
                label="Locality Cities"
                handleChange={handleChange}
                remoteSearchApplicable
                remoteSearchKey="startswith"
                activeElement={inputFieldState.geography_details}
                appliedFilters={{}}
                getActiveItemById={props.getBulkCities}
                multiple
              />
            </InputElements>
          </FlexContainer>
        )}
        <FlexContainer className="justify-start">
          <NamesDiv>
            <p className="regular ml-10 mb-30">
              Select{" "}
              {getInputLabel(
                inputFieldState.geography_details.geography_level,
                geographyLevelType,
                "value",
                "label"
              )}
            </p>
          </NamesDiv>
          <InputElements>{getGeographySelectedDropdown()}</InputElements>
        </FlexContainer>
        <FlexContainer className="justify-start">
          <NamesDiv>
            <p className="regular ml-10 mb-30">Select Driver Services</p>
          </NamesDiv>
          <InputElements>
            <InfiniteScrollDropdown
              priorityFlag={driverServicesPriorityFlag}
              setPriorityFlag={setDriverServicesPriorityFlag}
              id="driverServiceDropdown"
              getActiveList={props.getDriverServices}
              resKey="driver_services"
              modalState="Edit"
              keyName="driver_service_ids"
              labelKey="name"
              getDataLabelKey="driver_services.name"
              keyTypeToSet="id"
              label="Driver Services"
              handleChange={handleChange}
              activeElement={inputFieldState.geography_details}
              getActiveItemById={props.getDriverServiceByIds}
              multiple
            />
          </InputElements>
        </FlexContainer>
        {newCampaignOptions.active_driver_options && (
          <FlexContainer className="justify-start">
            <NamesDiv>
              <p className="regular ml-10 mb-30">Active Driver Selection</p>
            </NamesDiv>
            <InputElements>
              <PaginatedReactDropdown
                placeholder=""
                options={newCampaignOptions.active_driver_options}
                labelKey="label"
                valueKey="value"
                data-testid="activeDriverSelection"
                value={getInputLabel(
                  inputFieldState.geography_details.active_driver_option,
                  newCampaignOptions.active_driver_options,
                  "value",
                  "label"
                )}
                handleChange={handleChange}
                keyToChange="active_driver_option"
                id="activeDriverSelection"
              />
            </InputElements>
          </FlexContainer>
        )}
      </div>
      <BottomSectionModal>
        <p className="font-10 text-grey mb-10">
          Note: Active Drivers are the drivers who have logged in and were
          online in the date range.
        </p>
      </BottomSectionModal>
      {formError.length > 0 ? (
        <div className={"error-state"}>{"*" + formError}</div>
      ) : (
        ""
      )}
    </NoFooterModal>
  );
};

const NamesDiv = styled.div`
  justify-content: flex-start;
  flex: 0 1 38%;
  p {
    font-family: "OkraRegular", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
      sans-serif !important;
  }
`;

const InputElements = styled.div`
  flex: 0 1 62%;
`;

function mapStateToProps(state) {
  const { Country, State, City, Locality } = state;
  return {
    nextPageCountry: Country.nextPage,
    nextPageState: State.nextPage,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCountryList: bindActionCreators(CountryActions.getCountryList, dispatch),
    getCountry: bindActionCreators(CountryActions.getCountry, dispatch),
    getStateList: bindActionCreators(StateActions.getStateList, dispatch),
    getBulkStates: bindActionCreators(StateActions.getBulkStates, dispatch),
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getBulkCities: bindActionCreators(CityActions.getBulkCities, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    getBulkLocalities: bindActionCreators(
      LocalityActions.getBulkLocalities,
      dispatch
    ),
    getDriverServices: bindActionCreators(
      DriverActions.getDriverServices,
      dispatch
    ),
    getDriverServiceByIds: bindActionCreators(
      DriverActions.getDriverServiceByIds,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeographyDetailsModal);
